
/* Variant metafield gallery slider */

(function () {
  let mobileScrollTimer = null;

  function getVariantId(gallery) {
    if (gallery.dataset.productMediaFallback === 'true') {
      return String(gallery.dataset.initialVariant);
    }

    const section = gallery.closest('.shopify-section') || document;

    const input = section.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (input && input.value) {
      return String(input.value);
    }

    const script = section.querySelector(
      'variant-selects script[data-selected-variant]'
    );

    if (script) {
      try {
        const variant = JSON.parse(script.textContent);
        if (variant && variant.id) return String(variant.id);
      } catch (error) {
        console.error('Variant JSON error:', error);
      }
    }

    return String(gallery.dataset.initialVariant);
  }

  function getVisibleItems(gallery) {
    return Array.from(
      gallery.querySelectorAll('[data-gallery-item]')
    ).filter(item => !item.hidden);
  }

  function getVisibleThumbnails(gallery) {
    return Array.from(
      gallery.querySelectorAll('[data-gallery-thumbnail]')
    ).filter(item => !item.hidden);
  }

  function slideTo(gallery, index) {
    const items = getVisibleItems(gallery);
    const thumbnails = getVisibleThumbnails(gallery);

    if (!items.length) return;

    index = Math.max(0, Math.min(index, items.length - 1));

    const track = gallery.querySelector('[data-gallery-track]');

    if (track) {
      track.style.transform =
        `translate3d(-${index * 100}%, 0, 0)`;
    }

    items.forEach((item, i) => {
      item.classList.toggle('is-active', i === index);

      if (i !== index) {
        item.querySelectorAll('video').forEach(video => video.pause());
      }
    });

    thumbnails.forEach((thumbnail, i) => {
      if (i === index) {
        thumbnail.setAttribute('aria-current', 'true');

        thumbnail.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      } else {
        thumbnail.removeAttribute('aria-current');
      }
    });

    const current = gallery.querySelector('[data-gallery-current]');
    const total = gallery.querySelector('[data-gallery-total]');

    if (current) current.textContent = String(index + 1);
    if (total) total.textContent = String(items.length);
  }

  function refreshGallery(gallery) {
    const variantId = getVariantId(gallery);

    gallery.querySelectorAll('[data-gallery-item]').forEach(item => {
      item.hidden = item.dataset.variantId !== variantId;
      item.classList.remove('is-active');

      item.querySelectorAll('video').forEach(video => video.pause());
    });

    gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(item => {
      item.hidden = item.dataset.variantId !== variantId;
      item.removeAttribute('aria-current');
    });

    const items = getVisibleItems(gallery);
    const empty = gallery.querySelector('[data-gallery-empty]');
    const controls = gallery.querySelector('.variant-gallery-controls');
    const thumbnails = gallery.querySelector('[data-gallery-thumbnails]');
    const track = gallery.querySelector('[data-gallery-track]');

    if (empty) empty.hidden = items.length > 0;
    if (controls) controls.hidden = items.length === 0;
    if (thumbnails) thumbnails.hidden = items.length === 0;

    if (track) {
      track.style.transition = 'none';
      track.style.transform = 'translate3d(0, 0, 0)';

      requestAnimationFrame(() => {
        track.style.transition = '';
      });
    }

    if (items.length) {
      slideTo(gallery, 0);
    }
  }

  function refreshAll() {
    document.querySelectorAll(
      '[data-variant-metafield-gallery]'
    ).forEach(refreshGallery);
  }

  function handleVariantChange() {
    window.setTimeout(refreshAll, 100);
    window.setTimeout(refreshAll, 350);

    window.setTimeout(() => {
      refreshAll();

      // Scroll to the very top on mobile after variant selection
      if (window.innerWidth < 750) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }, 500);
  }

  function move(gallery, direction) {
    const items = getVisibleItems(gallery);

    const activeIndex = items.findIndex(item =>
      item.classList.contains('is-active')
    );

    if (!items.length) return;

    const nextIndex =
      (Math.max(activeIndex, 0) + direction + items.length) % items.length;

    slideTo(gallery, nextIndex);
  }

  // Thumbnail and arrow clicks
  document.addEventListener('click', function (event) {
    const gallery = event.target.closest(
      '[data-variant-metafield-gallery]'
    );

    if (!gallery) return;

    const thumbnail = event.target.closest('[data-gallery-thumbnail]');

    if (thumbnail && !thumbnail.hidden) {
      event.preventDefault();

      const thumbnails = getVisibleThumbnails(gallery);
      const index = thumbnails.indexOf(thumbnail);

      if (index !== -1) slideTo(gallery, index);
      return;
    }

    if (event.target.closest('[data-gallery-prev]')) {
      event.preventDefault();
      move(gallery, -1);
      return;
    }

    if (event.target.closest('[data-gallery-next]')) {
      event.preventDefault();
      move(gallery, 1);
    }
  });

  // Detect variant changes
  document.addEventListener('change', function (event) {
    const changedVariant =
      event.target.closest('variant-selects, variant-radios') ||
      event.target.matches('input[name="id"]');

    if (!changedVariant) return;

    window.clearTimeout(mobileScrollTimer);

    mobileScrollTimer = window.setTimeout(handleVariantChange, 80);
  });

  // Support Shopify theme editor section reloads
  document.addEventListener('shopify:section:load', refreshAll);

  // Swipe left and right on the main gallery
  document.addEventListener('touchstart', function (event) {
    const gallery = event.target.closest(
      '[data-variant-metafield-gallery]'
    );

    if (!gallery || !event.touches.length) return;

    gallery.dataset.touchStartX = String(event.touches[0].clientX);
    gallery.dataset.touchStartY = String(event.touches[0].clientY);
  }, { passive: true });

  document.addEventListener('touchend', function (event) {
    const gallery = event.target.closest(
      '[data-variant-metafield-gallery]'
    );

    if (!gallery || !event.changedTouches.length) return;

    const startX = Number(gallery.dataset.touchStartX || 0);
    const startY = Number(gallery.dataset.touchStartY || 0);
    const endX = event.changedTouches[0].clientX;
    const endY = event.changedTouches[0].clientY;

    const differenceX = startX - endX;
    const differenceY = startY - endY;

    if (
      Math.abs(differenceX) > 50 &&
      Math.abs(differenceX) > Math.abs(differenceY)
    ) {
      move(gallery, differenceX > 0 ? 1 : -1);
    }
  }, { passive: true });

  // Initial gallery setup
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
